<template>
    <div class="AdminDashboard flex col-center-stretch">
        <div class="Container flex row-stretch">
            <WCard>
                <div class="Section flex col-stretch">
                    <div class="Icon">
                        <WIcon
                            icon="management"
                            color="primary"
                            :size="118"
                        />
                    </div>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.GPS } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.gps.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.gps.description') }}</WText>
                        </div>
                    </a>
                </div>
            </WCard>
            <WCard>
                <div class="Section flex col-stretch">
                    <div class="Icon">
                        <WIcon
                            icon="money_increase"
                            color="primary"
                            :size="118"
                        />
                    </div>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.FUNDS } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.funds.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.funds.description') }}</WText>
                        </div>
                    </a>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.FUNDS_PERF } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.funds-perf.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.funds-perf.description') }}</WText>
                        </div>
                    </a>
                </div>
            </WCard>
            <WCard>
                <div class="Section flex col-stretch">
                    <div class="Icon">
                        <WIcon
                            icon="deal_2"
                            color="primary"
                            :size="118"
                        />
                    </div>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.TRANSACTIONS } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.trans.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.trans.description') }}</WText>
                        </div>
                    </a>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.TRANSACTIONS_PERF } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.trans-perf.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.trans-perf.description') }}</WText>
                        </div>
                    </a>
                </div>
            </WCard>
            <WCard>
                <div class="Section flex col-stretch">
                    <div class="Icon">
                        <WIcon
                            icon="briefcase_2"
                            color="primary"
                            :size="118"
                        />
                    </div>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.COMPANIES } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.companies.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.companies.description') }}</WText>
                        </div>
                    </a>
                    <a
                        class="Item"
                        @click.prevent="handleClick({ name: 'AdminEntityList', params: { entityKey: entities.COMPANIES_EVOL } })"
                    >
                        <div class="Wrapper">
                            <div class="Summary flex flex-1 row-stretch-center">
                                <WText
                                    size="20"
                                    class="Title"
                                    color="gray01"
                                >{{ $t('dashboard.sections.companies-evol.title') }}</WText>
                                <WIcon
                                    icon="chevron-right"
                                    color="gray01"
                                    :size="24"
                                />
                            </div>
                            <WText color="gray02">{{ $t('dashboard.sections.companies-evol.description') }}</WText>
                        </div>
                    </a>
                </div>
            </WCard>
        </div>
        <div class="Separator" />
        <div class="Container flex row-center-stretch">
            <WCard class="Min">
                <a
                    class="Section flex row-stretch-center"
                    @click.prevent="handleClick({ name: 'AdminImportsList' })"
                >
                    <WIcon
                        icon="upload-cloud"
                        color="primary"
                        :size="52"
                        class="pl-1"
                    />
                    <div class="flex-1 pl-2 pr-1">
                        <WText
                            size="20"
                            class="Title"
                            color="gray01"
                        >{{ $t('dashboard.sections.imports.title') }}</WText>
                        <WText color="gray02">{{ $t('dashboard.sections.imports.description') }}</WText>
                    </div>
                </a>
            </WCard>
            <WCard class="Min">
                <a
                    class="Section flex row-stretch-center"
                    @click.prevent="handleClick({ name: 'AdminBuilder' })"
                >
                    <WIcon
                        icon="sliders"
                        color="primary"
                        :size="52"
                        class="pl-1"
                    />
                    <div class="flex-1 pl-2 pr-1">
                        <WText
                            size="20"
                            class="Title"
                            color="gray01"
                        >{{ $t('dashboard.sections.schemaBuilder.title') }}</WText>
                        <WText color="gray02">{{ $t('dashboard.sections.schemaBuilder.description') }}</WText>
                    </div>
                </a>
            </WCard>
            <WCard class="Min">
                <a
                    class="Section flex row-stretch-center"
                    @click.prevent="handleClick({ name: 'AdminUsers' })"
                >
                    <WIcon
                        icon="users"
                        color="primary"
                        :size="52"
                        class="pl-1"
                    />
                    <div class="flex-1 pl-2 pr-1">
                        <WText
                            size="20"
                            class="Title"
                            color="gray01"
                        >{{ $t('dashboard.sections.users.title') }}</WText>
                        <WText color="gray02">{{ $t('dashboard.sections.users.description') }}</WText>
                    </div>
                </a>
            </WCard>
        </div>
    </div>
</template>

<script>
import { ENTITY_TYPES } from '@/entities/entities'

export default {
    name: 'AdminDashboard',

    beforeMount () {
        this.entities = ENTITY_TYPES
    },
    methods: {
        handleClick ({ name, params }) {
            this.$router.push({ name, params })
        },
    },
}
</script>
<style lang="scss" scoped>
.AdminDashboard {
    width: 100%;
    max-width: 1280px;
    min-height: calc(100vh - #{$navbar-height} - 40px);
    margin: 0 auto;
}

.Separator {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid $gray-05;
}

.WCard {
    min-height: 335px;
    width: 100%;
    max-width: 300px;
    border: 1px solid $gray-05;
    border-radius: $border-radius;
    box-sizing: border-box;

    &::v-deep .Body {
        padding: 0;
    }

    & + .WCard {
        margin-left: 30px;
    }

    &.Min {
        min-height: auto;
        max-width: 100%;
    }
}

.Section {
    padding: 15px;
}

.Icon {
    width: 100%;
    max-width: 100px;
    padding: 30px 15px;
}

.Wrapper {
    width: 100%;
}

.Item {
    display: flex;
    align-items: center;
    padding: 10px 15px;

    & + .Item {
        border-top: 1px solid $gray-05;
    }

    .Summary {
        margin-bottom: 5px;
    }

    .WText.Title {
        line-height: 1.2;
    }
}

a {
    &:hover {
        background-color: rgba($primary, .15);
    }
}
</style>
